import { useState, useEffect } from "react";

export default function useStoredState(name, defaultValue = null) {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(`value:${name}`);

    if (storedValue !== null) {
      return JSON.parse(storedValue);
    }

    return defaultValue;
  });

  useEffect(() => {
    localStorage.setItem(`value:${name}`, JSON.stringify(value));
  }, [value]);

  return [value, setValue];
}
